import { __assign } from "tslib";
import { filterProps, getNamedFormat } from './utils';
import { IntlError } from './error';
var DATE_TIME_FORMAT_OPTIONS = ['localeMatcher', 'formatMatcher', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName', 'hourCycle', 'dateStyle', 'timeStyle', 'fractionalSecondDigits', 'calendar', // 'dayPeriod',
'numberingSystem'];
export function getFormatter(_a, type, getDateTimeFormat, options) {
  var locale = _a.locale,
      formats = _a.formats,
      onError = _a.onError,
      timeZone = _a.timeZone;

  if (options === void 0) {
    options = {};
  }

  var format = options.format;

  var defaults = __assign(__assign({}, timeZone && {
    timeZone: timeZone
  }), format && getNamedFormat(formats, type, format, onError));

  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);

  if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = __assign(__assign({}, filteredOptions), {
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  return getDateTimeFormat(locale, filteredOptions);
}
export function formatDate(config, getDateTimeFormat) {
  var _a = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    _a[_i - 2] = arguments[_i];
  }

  var value = _a[0],
      _b = _a[1],
      options = _b === void 0 ? {} : _b;
  var date = typeof value === 'string' ? new Date(value || 0) : value;

  try {
    return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
  } catch (e) {
    config.onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting date.', e));
  }

  return String(date);
}
export function formatTime(config, getDateTimeFormat) {
  var _a = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    _a[_i - 2] = arguments[_i];
  }

  var value = _a[0],
      _b = _a[1],
      options = _b === void 0 ? {} : _b;
  var date = typeof value === 'string' ? new Date(value || 0) : value;

  try {
    return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
  } catch (e) {
    config.onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting time.', e));
  }

  return String(date);
}
export function formatDateTimeRange(config, getDateTimeFormat) {
  var _a = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    _a[_i - 2] = arguments[_i];
  }

  var from = _a[0],
      to = _a[1],
      _b = _a[2],
      options = _b === void 0 ? {} : _b;
  var timeZone = config.timeZone,
      locale = config.locale,
      onError = config.onError;
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? {
    timeZone: timeZone
  } : {});

  try {
    return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
  } catch (e) {
    onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting date time range.', e));
  }

  return String(from);
}
export function formatDateToParts(config, getDateTimeFormat) {
  var _a = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    _a[_i - 2] = arguments[_i];
  }

  var value = _a[0],
      _b = _a[1],
      options = _b === void 0 ? {} : _b;
  var date = typeof value === 'string' ? new Date(value || 0) : value;

  try {
    return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
  } catch (e) {
    config.onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting date.', e));
  }

  return [];
}
export function formatTimeToParts(config, getDateTimeFormat) {
  var _a = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    _a[_i - 2] = arguments[_i];
  }

  var value = _a[0],
      _b = _a[1],
      options = _b === void 0 ? {} : _b;
  var date = typeof value === 'string' ? new Date(value || 0) : value;

  try {
    return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
  } catch (e) {
    config.onError(new IntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting time.', e));
  }

  return [];
}